module.exports = __webpack_public_path__ + "img/home_bgtwo.f2dec872.png";